export default __webpack_public_path__ + "static/media/Sub-FolderIcon.4bea6e20.svg";